import React, { useState, useEffect } from "react";
import axios from "axios";
import FAQ from "./Faqs";
import { Link } from "react-router-dom";

const Projects = () => {
  // State for portfolio data from API
  const [portfolio, setPortfolio] = useState([]);
  const [loading, setLoading] = useState(true);
  
  // State to handle selected tab
  const [selectedTab, setSelectedTab] = useState("All");

  // State to control modal visibility and selected project
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);

  // Fetch portfolio data from API
  useEffect(() => {
    fetchPortfolio();
  }, []);

  const fetchPortfolio = async () => {
    try {
      const res = await axios.get("https://dataap.werkeon.com/api/get_portfolio.php");
      setPortfolio(res.data);
      setLoading(false);
    } catch (err) {
      console.error("Error fetching portfolio:", err);
      setLoading(false);
    }
  };

  // Map your categories to match the existing filter system
  const categoryMap = {
    'website': 'Web Design',
    'mobileApp': 'App Development', 
    'graphic': 'Branding',
    'digital': 'Digital Marketing' // Add this if you have digital category
  };

  // Transform API data to match your existing structure
  const transformedProjects = portfolio.map((item, index) => ({
    id: item.id,
    title: item.title || `Project ${item.id}`,
    category: categoryMap[item.service_id] || 'Other',
    image: item.image,
    link: null // You can add links later if needed
  }));

  // Filter projects based on selected category
  const filteredProjects =
    selectedTab === "All"
      ? transformedProjects
      : transformedProjects.filter((project) => project.category.includes(selectedTab));

  // Open modal with clicked project
  const openModal = (project) => {
    setSelectedProject(project);
    setModalOpen(true);
  };

  // Close modal
  const closeModal = () => {
    setModalOpen(false);
    setSelectedProject(null);
  };

  // Show loading state
  if (loading) {
    return (
      <section id="portfolio" className="portfolio-section py-8 pb-0 md:py-16 px-4">
        <div className="container mx-auto text-center">
          <div className="text-center mb-4 md:mb-12">
            <span className="text-4xl font-bold mb-4 text-center text-black border-b-2 border-[#E12126] uppercase">
              Our Portfolio
            </span>
          </div>
            <div className="loading-breathing">     
    {/* <svg  className="logo-breathing" aria-hidden="true" class="inline w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
    </svg>             */}
                  <img
                    src="../images/logos/header-logo.png"
                    alt="Website Logo"
                    className="logo-breathing"
                  />
                </div>
        </div>
      </section>
    );
  }

  return (
    <>
      <section id="portfolio" className="portfolio-section py-8 pb-0 md:py-16 px-4">
        <div className="container mx-auto">
          <div className="text-center mb-4 md:mb-12">
            <span className="text-4xl font-bold mb-4 text-center text-black border-b-2 border-[#E12126] uppercase">
              Our Portfolio
            </span>
            <p className="text-balance mt-4 text-[12px] md:text-[16px]">
              Explore our portfolio to see how we bring ideas to life through custom websites, apps, branding, and marketing. 
              Each project reflects our focus on quality, innovation, and real business results. We turn client goals into impactful digital solutions that drive growth.
            </p>
          </div>
          
          <div className="flex flex-col md:flex-row grid grid-cols-2 md:grid-cols-4 lg:grid-cols-4 mx-auto w-full max-w-7xl items-center mb-8">
            <button
              className={`filter-button hover:bg-[#21AA4A] text-[10px] md:text-[16px] px-4 py-2 mr-2 mb-2 text-white rounded ${
                selectedTab === "All" ? "bg-[#21AA4A]" : "bg-[#175293]"
              }`}
              onClick={() => setSelectedTab("All")}
            >
              All
            </button>
            <button
              className={`filter-button hover:bg-[#21AA4A] text-[10px] md:text-[16px] px-4 py-2 mr-2 mb-2 text-white rounded ${
                selectedTab === "Web Design" ? "bg-[#21AA4A]" : "bg-[#175293]"
              }`}
              onClick={() => setSelectedTab("Web Design")}
            >
              Websites
            </button>
            <button
              className={`filter-button hover:bg-[#21AA4A] text-[10px] md:text-[16px] px-4 py-2 mr-2 mb-2 text-white rounded ${
                selectedTab === "App Development" ? "bg-[#21AA4A]" : "bg-[#175293]"
              }`}
              onClick={() => setSelectedTab("App Development")}
            >
              Applications
            </button>
            <button
              className={`filter-button hover:bg-[#21AA4A] text-[10px] md:text-[16px] px-4 py-2 mr-2 mb-2 text-white rounded ${
                selectedTab === "Branding" ? "bg-[#21AA4A]" : "bg-[#175293]"
              }`}
              onClick={() => setSelectedTab("Branding")}
            >
              Graphics
            </button>
          </div>

          {/* Portfolio Grid */}
          {filteredProjects.length > 0 ? (
            <div className="grid mx-auto w-full max-w-7xl grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-10">
              {filteredProjects.map((project) => (
                <div
                  key={project.id}
                  className="group portfolio-item relative hover:shadow-lg shadow-md rounded-lg overflow-hidden cursor-pointer"
                  onClick={() => openModal(project)}
                >
                  <img
                    className="w-full h-60 object-cover"
                    src={project.image}
                    alt={project.title}
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-r from-green-500 to-yellow-500 opacity-0 transition duration-300 ease-in-out group-hover:opacity-40 flex items-center justify-center">
                    <img className="w-60 mb-10" src="../images/logos/header-logo.png" alt="Logo" />
                  </div>
                  <div className="p-4 flex flex-col items- text-left lg:items-center lg:text-center justify-between relative z-10">
                    <h3 className="text-lg max-w-[90%] md:w-full font-medium text-txt group-hover:text-gray-dark truncate">
                      {project.title}
                    </h3>
                    <span className="text-sm max-w-[90%] md:w-full font-bold text-blue-500 group-hover:text-indigo-500 truncate">
                      {project.category}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-12">
              <p className="text-gray-500">No portfolio items found.</p>
            </div>
          )}
        </div>

        <div className="bg-white-A700 mt-20 sm:mt-5 sm:mb-5 md:mb-0 mb-20 flex flex-col items-center justify-start sm:m-auto py-[18.16px] shadow backdrop-blur-lg w-full">
          <p className="text-left tablet capitalize leading-[150.00%] sm:text-[16.42px] md:text-[23.42px] text-[25.42px] text-black-900 text-center font-lato font-semibold">
            For any queries, don't hesitate to reach out to us. You deserve the best.
          </p>
          <Link to="/contact-us" className="mt-6 px-6 py-2 bg-[#175293] text-white m-auto rounded-md shadow-lg hover:bg-blue-600">
            Contact us
          </Link>
        </div>
        <FAQ />

        {/* Modal */}
        {modalOpen && selectedProject && (
          <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75 p-4"
            onClick={closeModal}
          >
            <div
              className="relative max-w-4xl w-full max-h-[90vh] bg-white rounded shadow-lg flex flex-col"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="flex justify-between items-center p-4 border-b border-gray-300">
                <h3 className="text-xl font-semibold">{selectedProject.title}</h3>
                <button
                  className="text-gray-600 hover:text-gray-900 text-2xl font-bold"
                  onClick={closeModal}
                  aria-label="Close modal"
                >
                  &times;
                </button>
              </div>

              <div className="flex-grow overflow-auto p-4 flex justify-center items-start">
                <img
                  src={selectedProject.image}
                  alt={selectedProject.title}
                  className=" w-full object-cover object-top rounded"
                />
              </div>

              {selectedProject.link && (
                <div className="p-4 border-t border-gray-300 text-center">
                  <a
                    href={selectedProject.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block px-6 py-2 bg-[#175293] text-white rounded hover:bg-blue-600 transition"
                  >
                    Visit Project
                  </a>
                </div>
              )}
            </div>
          </div>
        )}
      </section>
    </>
  );
};

export default Projects;